import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function InsuranceSection() {
  const [content, setContent] = useState({});
  const [isInsuranceOpen, setIsInsuranceOpen] = useState(false);

  useEffect(() => {
    // Henter kun innhold for 'bedrift'-siden, som er der vi har forsikrings-teksten
    axios.get(`${API_URL}/api/content/bedrift`).then(res => {
      const organized = res.data.reduce((acc, item) => ({ ...acc, [item.element_id]: item }), {});
      setContent(organized);
    });
  }, []);

  const insuranceList = content.bedrift_forsikring_liste?.value.split(',') || [];

// --- ERSTATT MED DENNE KORREKTE KODEN ---
  return (
    <div className="card info-box-static">
      {/* Denne wrapperen sørger for at innholdet fyller plassen og dytter dropdownen ned */}
      <div className="card-content-wrapper">
        <h3>{content.bedrift_boks3_tittel?.value}</h3>
        
        {/* Teksten er nå inne i den voksende wrapperen */}
        {content.bedrift_boks3_tekst_utvidet?.value.split('|').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
      
      {/* Dropdownen ligger nå ETTER wrapperen, og blir dyttet til bunnen */}
      <div className="insurance-dropdown-container">
        <button onClick={() => setIsInsuranceOpen(!isInsuranceOpen)} className="insurance-toggle-button">
          <h4>Forsikringspartnere</h4>
          <span className={`info-button-arrow ${isInsuranceOpen ? 'open' : ''}`}>&#8250;</span>
        </button>
        <div className={`info-panel ${isInsuranceOpen ? 'open' : ''}`}>
          <div className="panel-content">
            <ul className="panel-list single-column">
              {insuranceList.map((item, index) => <li key={index}>{item}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsuranceSection;